/*=========================================================================================
  File Name: moduleKVDRManagement.js
  Description: KVDR module
  ----------------------------------------------------------------------------------------
  Item Name: KVDR - key value driving role
  Author: Ashwani Bhardwaj
  Author Email: bhardwaj.ashwani92@gmail.com
==========================================================================================*/


import state from './moduleKVDRState.js'
import mutations from './moduleKVDRMutations.js'
import actions from './moduleKVDRActions.js'
import getters from './moduleKVDRGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

